import CombatEncounter from "@frog/source/models/CombatEncounter.js"

export default class Game {
    update(delta) {
        if(this.encounter != undefined
        && this.encounter.update != undefined) {
            this.encounter.update(delta)
        }
    }
    load(game) {
        if(game.encounter != undefined) {
            if(game.encounter.type == "combat") {
                this.encounter = CombatEncounter.load(game.encounter)
            }
            // else if(encounter.type == "draft") {
            //     this.encounter = DraftEncounter.load(game.encounter)
            // }

        }
        return this
    }
}
